export default __webpack_public_path__ + "locales/de/Ldap.json?hash=23228944c28d6451b330eaccaab8a66b";